export enum SourceType {
  UNSPECIFIED = 'Unspecified',
  PROVIDER_FACILITY_RETRIEVAL = 'Provider Facility Retrieval',
  MEDICATIONS_DIGITAL_DATA = 'Medications Digital Data',
  HIE_DATA = 'HIE Data',
}
